import React, { FC } from 'react'
import { cn } from 'shared/utils'

import { INavTabsProps } from './Nav.props'
import './Nav.scss'
import { ConditionRender } from 'components'

const NavTabs: FC<INavTabsProps> = ({ navs, setActiveTab, activeTab }) => (
  <ul className="nav nav--subnav navigation-menu">
    {navs.map(({ label, value, count }, index) => (
      <li
        key={index}
        onClick={() => setActiveTab(value)}
        className={cn('nav-item', {
          active: activeTab === value,
          passive: count === 0
        })}
      >
        <b className="nav-link nav-item-link">{label}</b>
        <ConditionRender condition={!!count} component={<span className="nav-item__count">{count}</span>} />
      </li>
    ))}
  </ul>
)

export default NavTabs
